import { memo } from 'react';
import ContainerBody from './ContainerBody';
import ContainerHeader from './ContainerHeader';
import { Recommendations } from '../../../containers/';
import { Container, Row, Col } from "react-bootstrap";
import { SIDE_TRAY_EXPAND_PERCENTAGE } from '../../../utils/global_variables';
import { BzToolTip } from '../../../components';


const SideRecommendations = ({ setIsExpanded, sideContentId, setActiveMenu, setActiveButtonToggleIndex, setSelectedRecommendation, setToggleSideContainer, ...props }) => {//BT- 112339:Watchlist||Side Tray | Closing functionality: ManasaB: 30/06/23


    return (
        <>
            <ContainerHeader header="RECOMMENDATIONS" sideContentId={sideContentId} setToggleSideContainer={setToggleSideContainer}>
                <Container fluid className='p-0'>
                    <Row className='g-0 stickysidemenu-top-header bdr-btm p-3'>
                        <Col md={10} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size5 color-text text-uppercase line-height-1'>RECOMMENDATIONS</div>
                            {props.children}
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-self-center'>
                            <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                <div className='icon-16 icon-dark icon-close' onClick={() => {
                                    setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
                                    setToggleSideContainer(false);
                                    setActiveMenu({});
                                    }}>                                
                                </div>
                            </BzToolTip>
                        </Col>
                    </Row>

                </Container>
            </ContainerHeader>

            <ContainerBody>
                <div className='sticky-recommendations-height'>
                    <Recommendations objLayOut={{ horizonatal: true, wrap: false }} />
                </div>
            </ContainerBody>
        </>
    );
};

export default memo(SideRecommendations);